import React from 'react';
import { motion } from 'framer-motion';
import { highlightMeta } from '../data/content';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { BlowoutIcon, ColorIcon, ExtensionsIcon, EventIcon, QuoteIcon, ScissorsIcon, TreatmentIcon } from './icons/GoldIcons';
const iconMap = {
  scissors: ScissorsIcon,
  blowout: BlowoutIcon,
  color: ColorIcon,
  treatment: TreatmentIcon,
  extensions: ExtensionsIcon,
  event: EventIcon
};
const ease = [0.23, 1, 0.32, 1] as const;
export function Highlights() {
  const {
    t
  } = useLanguage();
  return <section id="experiencia" className="w-full bg-ink-900 py-24 sm:py-32" data-id="element-138" data-mp="38zqrauxo5y1e">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-139" data-mp="3dzlf2pm5e7i8">
        <SectionHeading eyebrow={t.highlights.eyebrow} title={t.highlights.title} intro={t.highlights.intro} data-id="element-140" data-mp="3e16f2ur8einh" />

        <div className="mt-16 grid grid-cols-1 gap-x-14 gap-y-12 md:grid-cols-2" data-id="element-141" data-mp="ocnnirj2f9vo">
          {highlightMeta.map((meta, index) => {
          const Icon = iconMap[meta.icon];
          const item = t.highlights.items[index];
          return <motion.article key={meta.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.4,
            ease,
            delay: index % 2 * 0.06
          }} className="group flex gap-6" data-id="element-142" data-mp="k9zxil0q9uko" data-mpi={index}>
                <span className="mt-1 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-gold-deep/40 bg-gold-deep/10 text-gold-soft transition-colors duration-200 group-hover:border-gold-soft group-hover:text-gold-ivory" data-id="element-143" data-mp="mshkirxsh4h">
                  <Icon className="h-7 w-7" data-id="element-144" data-mp="3nst58h6trp6x" />
                </span>
                <div data-id="element-145" data-mp="3isf13a8cgze6">
                  <h3 className="font-display text-2xl font-medium text-gold-bright" data-id="element-146" data-mp="3irnegowq6c01">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-[15px] italic text-neutral-400" data-id="element-147" data-mp="345gatil84b11">{item.lead}</p>
                  <p className="mt-3 leading-relaxed text-neutral-300" data-id="element-148" data-mp="347symcdnxfm0">{item.body}</p>
                </div>
              </motion.article>;
        })}
        </div>

        <figure className="mx-auto mt-20 max-w-3xl rounded-3xl border border-gold-deep/30 bg-[radial-gradient(ellipse_at_top,rgba(212,168,87,0.12),transparent_65%)] px-8 py-10 text-center" data-id="element-149" data-mp="2v637l7np0ior">
          <QuoteIcon className="mx-auto h-7 w-7 text-gold-glow/70" data-id="element-150" data-mp="3mwzdtpf8zp32" />
          <blockquote className="mt-5 font-display text-xl italic leading-relaxed text-neutral-200 sm:text-2xl" data-id="element-151" data-mp="3rurasxur21e4">
            “{t.highlights.eventTestimonial.quote}”
          </blockquote>
          <figcaption className="mt-6 text-[12px] uppercase tracking-[0.24em] text-gold-muted" data-id="element-152" data-mp="3i57t3virwdku">
            {t.highlights.eventTestimonial.author}
          </figcaption>
        </figure>
      </div>
    </section>;
}